import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import config from './config';
import util from '../util';
import env from '../env';
import isPlainObject from 'lodash-es/isPlainObject';
import { openMiddlePage } from './utils/helpers';
export var canGetInstallState = true;
var qqapiready = false;
export function ready() {
  return new Promise(function (resolve) {
    if (qqapiready) {
      resolve();
    } else {
      util.loadScript('qqapi', '//open.mobile.qq.com/sdk/qqapi.js?_bid=152', function () {
        qqapiready = true;
        resolve();
      });
    }
  });
}
export function getInstallState() {
  return _getInstallState.apply(this, arguments);
}

function _getInstallState() {
  _getInstallState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var conf,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            conf = _args.length > 0 && _args[0] !== undefined ? _args[0] : config;
            _context.next = 3;
            return ready();

          case 3:
            return _context.abrupt("return", new Promise(function (resolve) {
              var value = env.isIphone ? conf.packageUrl : conf.packageName;

              if (mqq.app.isAppInstalled) {
                mqq.app.isAppInstalled(value, function (installed) {
                  if (isPlainObject(installed)) {
                    resolve(installed.result);
                  } else {
                    resolve(installed);
                  }
                });
              } else {
                mqq.invoke('app', 'isAppInstalled', {
                  name: value
                }, function (installed) {
                  resolve(installed);
                });
              }
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getInstallState.apply(this, arguments);
}

export function launch(_x) {
  return _launch.apply(this, arguments);
}

function _launch() {
  _launch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(schemeUrl) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return ready();

          case 2:
            window.location.href = schemeUrl;
            return _context2.abrupt("return", true);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _launch.apply(this, arguments);
}

export function download() {
  return _download.apply(this, arguments);
}

function _download() {
  _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var conf,
        isOpenAppPage,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            conf = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : config;
            isOpenAppPage = openMiddlePage(); // 只有 openapp 中间页才拉起下载

            if (isOpenAppPage) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return");

          case 4:
            if (env.isIos) {
              mqq.app.launchApp(conf.download);
            } else if (env.isAndroid) {
              window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=".concat(conf.packageName);
            }

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _download.apply(this, arguments);
}

export default {
  canGetInstallState: canGetInstallState,
  ready: ready,
  getInstallState: getInstallState,
  launch: launch,
  download: download
};